import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetCourtList } from "../../../utilities/api/courts";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

type CourtsListType = {
  name: string;
  facility: string;
  sport: string;
  timing: string;
  id: string;
};

const initialState = {
  AllCourtsData: [] as CourtsListType[],
  errorMessage: {} as ErrorMessageType,
};

export const AllCourtsList = createAsyncThunk(
  "CourtsList/AllCourtsList",
  (payload: any = {}) => GetCourtList(payload?.facilityId, payload?.sportId)
);

const CourtsListSlice = createSlice({
  name: "CourtsList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(AllCourtsList.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload.statusCode === 200) {
          state.AllCourtsData = action.payload.data.rows.map((item: any) => ({
            name: item.name,
            facility: item.facility.name,
            sport: item.sport.name,
            timing: `${item.openTime.slice(0, 5)} to ${item.closeTime.slice(
              0,
              5
            )}`,
            id: item.id,
            status: item.isActive ? "Active" : "Inactive",
          }));
        }
      })
      .addCase(AllCourtsList.rejected, (state, action) => {
        state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default CourtsListSlice.reducer;
